import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DeviceCalibrationHistory } from '../models/deviceCalibrationHistory.model';
import { GridService } from '../shared/grid/grid.service';

@Injectable({
    providedIn: 'root'
})
export class DeviceCalibrationHistoryService extends GridService<DeviceCalibrationHistory> {
    constructor(http: HttpClient) {
        super('DeviceCalibrationHistory', http);
    }

}
